var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayArrowLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "30 336.7 120.9 129.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:#FFD400;}\r\n    .st1{fill:#FF3333;}\r\n    .st2{fill:#48FF48;}\r\n    .st3{fill:#3BCCFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.2 421.2c15.3-8.4 27-14.8 28-15.3 3.2-1.7 6.5-6.2 0-9.7 -2.1-1.1-13.4-7.3-28-15.3l-20.1 20.2L119.2 421.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1 401.1l-64.2 64.7c1.5 0.2 3.2-0.2 5.2-1.3 4.2-2.3 48.8-26.7 79.1-43.3L99.1 401.1 99.1 401.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.1 401.1l20.1-20.2c0 0-74.6-40.7-79.1-43.1 -1.7-1-3.6-1.3-5.3-1L99.1 401.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.1 401.1l-64.3-64.3c-2.6 0.6-4.8 2.9-4.8 7.6 0 7.5 0 107.5 0 113.8 0 4.3 1.7 7.4 4.9 7.7L99.1 401.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayArrowLogo);
export default __webpack_public_path__ + "static/media/Google_Play_Arrow_logo.3041f828.svg";
export { ForwardRef as ReactComponent };